import * as login from './login';
import * as user from './user';
import * as device from './device';
import * as vehicle from './vehicle';
import * as geofence from './geofence';
import * as notification from './notification';
import * as reporting from './reporting';
import * as maintenance from './maintenance';

const API = { login, user, device, vehicle, geofence, notification, reporting, maintenance };

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js